<template>
  <div class="createRefund">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
      :before-close="handleClose"
    >
      <template v-if="status !== 'add' && refundData.status === 5">
        <div class="title"><span class="title_inside"></span>驳回原因</div>
        <div class="rejectReason_box">{{ refundData.rejectReason }}</div>
      </template>

      <div class="title">
        <span class="title_inside"></span>
        <span v-if="status === 'add'">填写工单信息</span>
        <span v-else-if="status === 'alter' || status === 'details'"
          >工单信息</span
        >
      </div>
      <el-form
        ref="formInline"
        :rules="rules"
        v-if="['add', 'alter'].includes(status)"
        :model="formInline"
        label-width="120px"
      >
        <el-form-item label="退费原因" prop="reason">
          <el-select v-model="formInline.reason" placeholder="请选择退费原因">
            <el-option label="个人原因" value="1"></el-option>
            <el-option label="其他" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款方式" prop="refundWay">
          <el-radio-group v-model="formInline.refundWay">
            <el-radio :label="1">原路退回</el-radio>
            <el-radio :label="2">指定账号</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="formInline.refundWay === 2">
          <el-form-item label="收款人姓名" prop="payeeName">
            <el-input
              placeholder="请输入收款人姓名"
              v-model="formInline.payeeName"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户行名" prop="receiveBank">
            <el-input
              placeholder="请输入开户行名"
              v-model="formInline.receiveBank"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户地区" prop="branch">
            <el-cascader
              v-model="formInline.branch"
              :options="options"
              :props="props"
              maxlength="20"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="开户支行" prop="branchBank">
            <el-input
              placeholder="请输入开户支行"
              v-model="formInline.branchBank"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行卡号" prop="bankNo">
            <el-input
              placeholder="请输入银行卡号"
              v-model="formInline.bankNo"
              maxlength="30"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item label="退费金额">
          {{ orderData.payAmt }}
        </el-form-item>
        <el-form-item label="发票处理方式" prop="billWay">
          <el-select
            v-model="formInline.billWay"
            placeholder="请选择发票处理方式"
          >
            <el-option label="未开发票" value="0"></el-option>
            <el-option label="电子发票注销" value="1"></el-option>
            <el-option label="纸质发票退回" value="2"></el-option>
            <el-option label="纸质发票丢失" value="3"></el-option>
            <el-option label="纸质发票已扣税点" value="4"></el-option>
            <el-option label="其他" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            type="textarea"
            placeholder="请输入备注"
            :rows="5"
            v-model="formInline.remarks"
            maxlength="500"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="凭证" prop="voucherImg">
          <el-upload
            ref="upload"
            list-type="picture-card"
            :format="['jpg', 'jpeg', 'png']"
            accept=".jpg, .JPG, .jpeg, .JPEG, .png, .PNG"
            :limit="9"
            :action="uploadHost"
            :data="uploadData"
            :file-list="formInline.voucherImg"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :on-exceed="handleExceed"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              最多课上传9张，每张不大于1M，可上传jpg、png、jpeg图片格式；
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-form
        v-if="status === 'details'"
        :model="refundData"
        label-width="120px"
      >
        <el-form-item label="退费原因">
          <span v-if="refundData.reason === 1">个人原因</span>
          <span v-else-if="refundData.reason === 2">其他</span>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="退款方式">
          <span v-if="refundData.refundWay === 1">原路退回</span>
          <span v-else-if="refundData.refundWay === 2">指定账号</span>
          <span v-else>--</span>
        </el-form-item>
        <template v-if="refundData.refundWay === 2">
          <el-form-item label="收款人姓名">
            {{ refundData.payeeName || "--" }}
          </el-form-item>
          <el-form-item label="开户行名">
            {{ refundData.receiveBank || "--" }}
          </el-form-item>
          <el-form-item label="开户地区">
            {{
              refundData.branchBankProvice + "--" + refundData.branchBankCity
            }}
          </el-form-item>
          <el-form-item label="开户支行">
            {{ refundData.branchBank || "--" }}
          </el-form-item>
          <el-form-item label="银行卡号" prop="bankNo">
            {{ refundData.bankNo || "--" }}
          </el-form-item>
        </template>
        <el-form-item label="退费金额">
          {{ orderData.payAmt || "--" }}
        </el-form-item>
        <el-form-item label="发票处理方式">
          <span v-if="refundData.billWay === 0">未开发票</span>
          <span v-else-if="refundData.billWay === 1">电子发票注销</span>
          <span v-else-if="refundData.billWay === 2">纸质发票退回</span>
          <span v-else-if="refundData.billWay === 3">纸质发票丢失</span>
          <span v-else-if="refundData.billWay === 4">纸质发票已扣税点</span>
          <span v-else-if="refundData.billWay === 5">其他</span>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="备注">
          {{ refundData.remarks || "--" }}
        </el-form-item>
        <el-form-item label="凭证">
          <div
            class="flx"
            v-if="refundData.voucherImg && refundData.voucherImg.length > 0"
          >
            <div
              class="flx_inner"
              v-for="(item, index) in refundData.voucherImg"
              :key="index"
            >
              <el-image
                style="width: 80px; height: 80px"
                :src="item"
                :preview-src-list="[item]"
              >
              </el-image>
            </div>
          </div>
          <span v-else>--</span>
        </el-form-item>
      </el-form>
      <div class="title"><span class="title_inside"></span>订单信息</div>
      <el-form :model="orderData" label-width="120px">
        <el-form-item label="订单编号">
          {{ orderData.orderNumber || "--" }}
        </el-form-item>
        <el-form-item label="支付金额">
          {{ orderData.payAmt || "--" }}
        </el-form-item>
        <template v-if="orderBool">
          <el-form-item label="支付方式">
            <span v-if="orderData.payType === 'WX'">微信</span>
            <span v-else-if="orderData.payType === 'ZFB'">支付宝</span>
            <span v-else-if="orderData.payType === 'JD'">京东</span>
            <span v-else-if="orderData.payType === 'APPLE'">苹果</span>
            <span v-else-if="orderData.payType === 'DGZZ'">线下转账</span>
            <span v-else-if="orderData.payType === 'YSF'">云闪付</span>
            <span v-else-if="orderData.payType === 'YLJH'">银联聚合</span>
            <span v-else>--</span>
          </el-form-item>
          <el-form-item label="收款商户号">
            {{ orderData.mchId || "--" }}
          </el-form-item>
          <el-form-item label="交易号">
            {{ orderData.tradeNo || "--" }}
          </el-form-item>
          <el-form-item label="收款公司">
            {{ orderData.payee || "--" }}
          </el-form-item>
          <el-form-item label="关联销售">
            {{ orderData.saleName || "--" }}
          </el-form-item>
        </template>
        <div class="show_box" @click="orderBool = !orderBool">
          {{ orderBool ? "收起" : "展开" }}
        </div>
      </el-form>
      <div class="title"><span class="title_inside"></span>发票信息</div>
      <el-form :model="invoiceData" label-width="120px">
        <el-form-item label="发票类型">
          <span v-if="invoiceData.invoiceTitle === 1">个人</span>
          <span v-else-if="invoiceData.invoiceTitle === 2">企业</span>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="发票金额">
          {{ invoiceData.invoiceAmt || "--" }}
        </el-form-item>
        <template v-if="invoiceBool">
          <el-form-item label="发票文件">
            <span
              class="blue_Box"
              v-if="invoiceData.invoiceUrl"
              @click="lookInvoice"
              >点击查看</span
            >
            <span v-else>--</span>
          </el-form-item>
          <el-form-item label="发票状态">
            <span v-if="invoiceData.status === 1">未开票</span>
            <span v-else-if="invoiceData.status === 2">已开票</span>
            <span v-else>--</span>
          </el-form-item>
        </template>
        <div class="show_box" @click="invoiceBool = !invoiceBool">
          {{ invoiceBool ? "收起" : "展开" }}
        </div>
      </el-form>
      <div v-if="status !== 'add'" class="title">
        <span class="title_inside"></span>操作日志
      </div>
      <template v-if="!workLogBool">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in workLogDataOne"
            :key="index"
            :icon="'el-icon-more'"
            :type="'primary'"
            :size="'large'"
            :timestamp="activity.insertDate"
          >
            <div style="word-break: break-all">
              【{{ activity.operator }}】
              <span style="margin-right: 16px">{{ activity.operateMsg }}</span>
              <span>{{ activity.remarks }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <template v-else>
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in workLogData"
            :key="index"
            :icon="index === 0 ? 'el-icon-more' : ''"
            :type="index === 0 ? 'primary' : ''"
            :size="index === 0 ? 'large' : ''"
            :timestamp="activity.insertDate"
          >
            <div style="word-break: break-all">
              【{{ activity.operator }}】
              <span style="margin-right: 16px">{{ activity.operateMsg }}</span>
              <span>{{ activity.remarks }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </template>
      <div
        v-if="workLogData.length > 1"
        class="show_box"
        @click="workLogBool = !workLogBool"
      >
        {{ workLogBool ? "收起" : "展开" }}
      </div>
      <span slot="footer" class="dialog-footer">
        <template v-if="status === 'add'">
          <el-button size="small" type="primary" @click="handleAffirm"
            >确 定</el-button
          >
        </template>
        <template v-if="status === 'alter'">
          <el-button size="small" @click="handleCancel">取消退费</el-button>
          <el-button size="small" type="primary" @click="handleAffirm"
            >确认提交</el-button
          >
        </template>
        <el-button size="small" @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from "@/libs/uploadFile";
import { getpublicImgUrl } from "@/api/base/api-upload";
import {
  getOrderDetail,
  getInvoiceByOrderId,
} from "@/api/orderAdmin/orderList";
import {
  createWorkData,
  updateWorkData,
  getRefundWorkData,
  getworkLogListPage,
  cancelRefundWorkData,
} from "@/api/refund/refundOrder.js";
import { cityJSON, TextToCode } from "@/utils/cityJson.js";
import { clone } from "@/utils/handle.js";
export default {
  data() {
    return {
      TextToCode,
      symbolReg: new RegExp(
        "[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]"
      ),
      props: {
        value: "name",
        label: "name",
        children: "cityList",
      },
      options: cityJSON,
      dialogTitle: "",
      dialogVisible: false,
      formInline: {
        reason: "",
        refundWay: "",
        payeeName: "",
        receiveBank: "",
        branch: [],
        branchBank: "",
        bankNo: "",
        // refundAmt: "",
        billWay: "",
        remarks: "",
        voucherImg: [],
        orderId: "",
      },
      rules: {
        reason: [
          { required: true, message: "请选择退费原因", trigger: "change" },
        ],
        refundWay: [
          { required: true, message: "请选择退费方式", trigger: "change" },
        ],
        payeeName: [
          { required: true, message: "请输入收款人姓名", trigger: "blur" },
        ],
        receiveBank: [
          { required: true, message: "请输入开户行", trigger: "blur" },
        ],
        branch: [
          { required: true, message: "请选择开户地区", trigger: "change" },
        ],
        branchBank: [
          { required: true, message: "请输入开户支行", trigger: "blur" },
        ],
        bankNo: [
          { required: true, message: "请输入银行卡号", trigger: "blur" },
        ],
        // refundAmt: [
        //   { required: true, message: "请输入退费金额", trigger: "blur" },
        // ],
        billWay: [
          { required: true, message: "请选择发票处理方式", trigger: "change" },
        ],
      },
      orderBool: false,
      orderData: {},
      invoiceBool: false,
      invoiceData: {},
      workLogData: [],
      workLogDataOne: [],
      workLogBool: false,
      refundData: {},
      uploadHost: "",
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
      status: "",
    };
  },
  methods: {
    // 查看发票
    lookInvoice() {
      window.open(this.invoiceData.invoiceUrl);
    },
    // 初始化
    init(status, payload) {
      this.status = status;
      if (status === "add") {
        this.dialogTitle = "创建退费工单";
      } else if (status === "alter" || status === "details") {
        this.dialogTitle = "查看工单详情";
      }
      this.initData(status);
      this.formInline.orderId = payload.id;
      this.asyncApiMeth(status, payload).then((res) => {
        this.orderData = res[0].data || {};
        this.invoiceData = res[1].data || {};
        if (status !== "add") {
          this.refundData = clone(res[2].data) || {};
          this.refundData.voucherImg = this.refundData.voucherImg ? this.refundData?.voucherImg?.split(",") : [];
          let refundWorkData = res[2].data || {};
          this.replenishData(refundWorkData);
          this.workLogData = res[3].data?.records || [];
          if (res[3].data?.records?.length > 0) {
            this.workLogDataOne = [res[3].data?.records[0]] || [];
          }
        }
        this.dialogVisible = true;
        if(['add', 'alter'].includes(status)){
          this.$nextTick(() => {
            this.$refs.formInline.clearValidate();
          });
        }
      });
    },
    // 取消退费
    handleCancel() {
      this.$confirm("确认要取消该退费吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cancelRefundWorkData({ id: this.refundData.id }).then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                type: "success",
                message: "取消成功!",
              });
            }
          });
        })
        .catch(() => {});
    },
    replenishData(payload) {
      let voucherImgList = payload.voucherImg ? payload.voucherImg?.split(",") : [];
      let arr = voucherImgList.map((item, index) => {
        return { name: `图片${index}`, url: item };
      });
      this.formInline = {
        reason: String(payload.reason) || "",
        refundWay: payload.refundWay || "",
        payeeName: payload.payeeName || "",
        receiveBank: payload.receiveBank || "",
        branch: [payload.branchBankProvice, payload.branchBankCity],
        branchBank: payload.branchBank || "",
        bankNo: payload.bankNo || "",
        billWay: String(payload.billWay) || "",
        remarks: payload.remarks || "",
        voucherImg: arr,
        orderId: payload.orderId,
      };
    },
    initData(status) {
      if (status === "add") {
        this.formInline = this.$options.data().formInline;
        this.orderBool = false;
        this.orderData = {};
        this.invoiceBool = false;
        this.invoiceData = {};
      }
    },
    asyncApiMeth(status, payload) {
      let orderId = status === "add" ? payload.id : payload.orderId;
      const orderDetailData = getOrderDetail({ orderId });
      const invoiceInfoData = getInvoiceByOrderId({ orderId });
      if (status !== "add") {
        const refundWorkData = getRefundWorkData({ id: payload.id });
        const workLogData = getworkLogListPage({
          page: 1,
          limit: -1,
          workDataId: payload.id,
        });
        return Promise.all([
          orderDetailData,
          invoiceInfoData,
          refundWorkData,
          workLogData,
        ]);
      }
      return Promise.all([orderDetailData, invoiceInfoData]);
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          if (this.formInline.refundWay === 2) {
            if (this.symbolReg.test(this.formInline.payeeName)) {
              this.$message({
                message: "请输入正确的收款人姓名",
                type: "warning",
              });
              return;
            }

            if (this.symbolReg.test(this.formInline.branchBank)) {
              this.$message({
                message: "请输入正确的开户行",
                type: "warning",
              });
              return;
            }

            if (this.symbolReg.test(this.formInline.receiveBank)) {
              this.$message({
                message: "请输入正确的开户支行",
                type: "warning",
              });
              return;
            }

            if (!/^(\d{16,19})$/.test(this.formInline.bankNo)) {
              this.$message({
                message: "请输入正确的卡号",
                type: "warning",
              });
              return;
            }
          }
          let params = clone(this.formInline);
          if (params.refundWay === 2) {
            params.branchBankProvice = params.branch[0];
            params.branchBankCity = params.branch[1];
            delete params.branch;
          }

          if (params.refundWay === 1) {
            delete params.payeeName;
            delete params.receiveBank;
            delete params.branch;
            delete params.branchBank;
            delete params.bankNo;
          }

          let arr = this.formInline.voucherImg.map((item) => {
            return item.url;
          });

          params.voucherImg = arr.join(",");

          if (this.status === "add") {
            createWorkData({ ...params }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          } else if (this.status === "alter") {
            updateWorkData({ ...params, id: this.refundData.id }).then(
              (res) => {
                if (res.code === 0) {
                  this.$parent.refresh();
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.dialogVisible = false;
                }
              }
            );
          }
        }
      });
    },
    // 上传前的回调函数
    beforeUpload(file) {
      return oss(file.name, 0, "").then((res) => {
        this.uploadHost = res.host;
        this.uploadData = res;
        this.fileData.fileName = res.key;
        this.fileData.oFileName = file.name;
      });
    },
    // 上传成功的回调函数
    handleSuccess(response, file, fileList) {
      // 获取公有链接
      getpublicImgUrl(this.fileData.fileName).then((res) => {
        if (res.code === 0) {
          file.url = res.data;
          this.formInline.voucherImg.push(file);
        } else {
          this.$message.success("获取图片链接失败");
        }
      });
    },
    // 图片删除
    handleRemove(file, fileList) {
      let data = this.formInline.voucherImg.filter((value, index) => {
        return value.url !== file.url;
      });
      this.formInline.voucherImg = data;
    },
    // 超出个数
    handleExceed() {
      this.$message({
        message: "最多上传9张图片！",
        type: "warning",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.createRefund {
  ::v-deep .el-dialog__body {
    padding: 16px 40px 30px 30px;
  }
  .rejectReason_box {
    border: 1px solid #dcdfe6;
    padding: 10px 16px 20px;
    word-break: break-all;
    margin-bottom: 26px;
  }
  .title {
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 22px;
    margin-left: 2px;
    .title_inside {
      display: inline-block;
      width: 4px;
      height: 18px;
      background: #4795f5;
      margin-right: 6px;
    }
  }
  .show_box {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    padding: 8px 0;
    font-size: 14px;
    margin-bottom: 30px;
    background-color: #ffffff;
  }
  .show_box:hover {
    background-color: #f9fafc;
  }
  .blue_Box {
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }

  .flx {
    display: flex;
    flex-wrap: wrap;
    .flx_inner {
      margin: 0 6px;
    }
  }
}
</style>
